import { Component, OnInit, ViewEncapsulation, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { Reservation } from '../../../../../../models/reservation';
import { DataService } from '../../../../../../_services/data.service';
import { ReservationService } from '../../../../../../services/reservation.service';
import { AdUnitService } from '../../../../../../services/adunit.service';
import {
    SelectService,
    SelectEvent
} from '../../../../../../_services/select.service';
import { ReservationDetail } from '../../../../../../models/reservation-detail';
import { ReservationDetailDate } from '../../../../../../models/reservation-detail-date';
import { ReservationCity } from '../../../../../../models/reservation-city';
import { map } from 'rxjs/operator/map';
import { LoadingService } from '../../../../../../_services/loading.service';
import {
    DatepickerService,
    DatepickerEvent
} from '../../../../../../_services/datepicker.service';
import { ApiError } from '../../../../../../models/api-error';

@Component({
    selector: 'app-reservation-create',
    templateUrl: './reservation-create.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ReservationCreateComponent extends BaseComponent
    implements OnInit {
    model: Reservation = new Reservation();
    adUnits: any[] = [];
    selectedAdUnits: any[] = [];
    selectedSiteId: any;
    filteredAdUnits: any[] = [];
    searchTargetKey: string = '';
    closedDates: any[] = [];

    constructor(
        private reservationService: ReservationService,
        private adUnitService: AdUnitService,
        private dataService: DataService,
        private selectService: SelectService,
        private loading: LoadingService,
        private datepickerService: DatepickerService,
        private router: Router
    ) {
        super();
        this.router.routeReuseStrategy.shouldReuseRoute = function() {
            return false;
        };
        this.model.publisherId = this.dataService.publisherId;
    }
    ngOnInit() {
        var self = this;
        this.selectService
            .init({
                url: '/agencies/list?filterId=' + this.model.publisherId,
                controlId: 'agencyId',
                displayProperty: 'name'
            })
            .on(SelectEvent.select, function(e) {
                self.model.agencyId = e.params.data.id;
            });

        this.selectService
            .init({
                url: '/cities/list',
                controlId: 'cityId',
                displayProperty: 'name',
                multiple: true,
                placeholder: ''
            })
            .on(SelectEvent.select, function(e) { });

        this.selectService
            .init({
                url: '/customers/list?filterId=' + this.model.publisherId,
                controlId: 'customerId',
                displayProperty: 'name'
            })
            .on(SelectEvent.select, function(e) {
                self.model.customerId = e.params.data.id;
            });

        this.selectService
            .init({
                url: '/sites/list?filterId=' + this.model.publisherId,
                controlId: 'siteId',
                displayProperty: 'title'
            })
            .on(SelectEvent.select, function(e) {
                self.selectedSiteId = e.params.data.id;
                self.getTargets();
            });
        (<any>$('#selectedTargetScrollBar')).mCustomScrollbar({
            axis: 'yx',
            advanced: { autoExpandHorizontalScroll: true },
            mouseWheel: { scrollAmount: 50 }
        });
    }

    addAdUnit() {
        var text = document.getElementById('addButton').textContent;
        if (text == '+') {
            document.getElementById('addButton').textContent = '-';
        } else {
            document.getElementById('addButton').textContent = '+';
        }
    }
    onTargetSelect(adUnit) {
        adUnit.dateCount = 0;

        this.selectedAdUnits.push(adUnit);
        this.selectedAdUnits.sort(function(a, b) {
            var nameA = a.page.name + '/' + a.title;
            var nameB = b.page.name + '/' + b.title;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        setTimeout(() => { }, 50);

        this.loadFilteredAdUnits();

    }

    searchTarget(event) {
        this.searchTargetKey = event.target.value.toLowerCase();
        this.loadFilteredAdUnits();
    }

    loadFilteredAdUnits() {
        var self = this;
        this.filteredAdUnits = this.adUnits.filter(function(a) {
            var selectedAdUnit = self.selectedAdUnits.filter(function(s) {
                return s.id == a.id;
            });
            return (
                selectedAdUnit.length == 0 &&
                (self.searchTargetKey == '' ||
                    a.title.toLowerCase().includes(self.searchTargetKey) ||
                    a.page.name.toLowerCase().includes(self.searchTargetKey))
            );
        });
        this.filteredAdUnits.sort(function(a, b) {
            var nameA = a.page.name + '/' + a.title;
            var nameB = b.page.name + '/' + b.title;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }
    onClickDate(adUnit) {
        this.loading.show();
        this.reservationService
            .getReservationAdUnitClosedDates(adUnit.id)
            .subscribe(res => {
                this.closedDates = res.data.dates.map(x => new Date(x));
                this.InitAdUnitDatepicker(adUnit);
                this.loading.hide();
            });
    }
    InitAdUnitDatepicker(adUnit) {
        var self = this;
        var startDate = new Date();
        var adUnitDatepicker = this.datepickerService.init(adUnit.id, {
            datesDisabled: this.closedDates,
            multiSelectWeek: true,
            multiSelectDays: true,
            startDate: startDate
        });
        adUnitDatepicker.onChangeDate(function() {
            var adUnitDates = self.datepickerService.getDates(adUnit.id);
            adUnit.dateCount = adUnitDates.length;
            if (adUnit.dateCount > 0)
                (<any>$('#badge' + adUnit.id)).addClass('m-badge--info');
            else (<any>$('#badge' + adUnit.id)).removeClass('m-badge--info');
        });
        adUnitDatepicker.onHide(function(event) {
            event.type = '';
        });
        // adUnitDatepicker.onShow(function() {});
        var type = (<any>$('#' + adUnit.id)).attr('type');
        if (type == 'focusin') {
            (<any>$('#' + adUnit.id)).trigger('blur');
            (<any>$('#' + adUnit.id)).attr('type', '');
        } else {
            (<any>$('.adUnitDatePicker')).attr('type', '');
            (<any>$('#' + adUnit.id)).trigger('focus');
            (<any>$('#' + adUnit.id)).attr('type', 'focusin');
        }
    }
    onSelectedTargetSelect(adUnit) {
        this.selectedAdUnits = this.selectedAdUnits.filter(function(obj) {
            return obj.id !== adUnit.id;
        });
        this.loadFilteredAdUnits();
    }
    getTargets() {
        var self = this;
        self.adUnits = [];
        this.loading.show();
        this.adUnitService.listBySiteId(this.selectedSiteId).subscribe(res => {
            self.adUnits = res.data;
            this.searchTargetKey = '';
            this.loadFilteredAdUnits();
            (<any>$('#targetScrollBar')).mCustomScrollbar({
                axis: 'yx',
                advanced: { autoExpandHorizontalScroll: true },
                mouseWheel: { scrollAmount: 50 }
                // callbacks:{
                //     onScrollStart: function(){
                //         Helpers.stopBodyScroll();
                //     },
                //     onScroll : function(){
                //        Helpers.startBodyScroll();
                //     }
                // }
            });
            this.loading.hide();
        });
    }
    createReservation() {
        this.loading.show();
        var self = this;
        this.model.reservationCities = [];
        this.model.reservationDetails = [];
        this.model.publisherId = this.dataService.publisherId;
        this.mapReservationDetails();
        this.mapReservationCities();

        this.reservationService.create(this.model).subscribe(res => {
            this.swalService.successCreate();
            self.router.navigate(['/publisher/reservation'], {
                queryParams: { tab: 2 }
            });
            this.loading.hide();
        });
    }
    mapReservationCities() {
        var selectedCities = this.selectService.getSelectedValues('cityId');
        for (let i = 0; i < selectedCities.length; i++) {
            const city = selectedCities[i];
            var reservationCity = new ReservationCity();
            reservationCity.cityId = city.id;
            this.model.reservationCities.push(reservationCity);
        }
    }
    mapReservationDetails() {
        for (let i = 0; i < this.selectedAdUnits.length; i++) {
            const adUnit = this.selectedAdUnits[i];
            var reservationDetail = new ReservationDetail();
            reservationDetail.adUnitId = adUnit.id;
            var adUnitDates = this.datepickerService.getDates(adUnit.id);
            if (adUnitDates.length < 1) {
                var apiError = new Error();
                apiError.message =
                    'There is no date selected on this Target = ' +
                    adUnit.page.site.title +
                    '/' +
                    adUnit.page.name +
                    '/' +
                    adUnit.title +
                    '  ';
                apiError['showMessage'] = true;
                throw apiError;
            }
            reservationDetail.reservationDetailDates = [];
            for (let k = 0; k < adUnitDates.length; k++) {
                // const date = Helpers.getUTCDate(adUnitDates[k]);
                const date = adUnitDates[k];
                var reservationDetailDate = new ReservationDetailDate();
                reservationDetailDate.date = date;
                reservationDetail.reservationDetailDates.push(reservationDetailDate);
            }
            this.model.reservationDetails.push(reservationDetail);
        }
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                reservationName: customRules.requiredText,
                customerId: {
                    required: true
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/reservation/reservation-create/reservation-create.component.ts